import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import CommonHome from '@/views/common/CommonHome.vue'
import HceCreateProfile from '@/views/hce-portal/HceCreateProfile.vue'
import HceEditProfile from '@/views/hce-portal/HceEditProfile.vue'
import HceHome from '@/views/hce-portal/HceHome.vue'
import HceTranscriptionTerms from '@/views/hce-portal/HceTranscriptionTerms.vue'
import HceEditranscriptionTerms from '@/views/hce-portal/HceEditranscriptionTerms.vue'
import Index from '@/views/Index.vue'
import DemographicsForm from '@/views/DemographicsForm.vue'
import Search from '@/components/Search.vue'
import EmailSearch from '@/components/EmailSearch.vue'
import ViewContact from '@/components/ViewContact.vue'
import Plan from '@/components/Plan.vue'
import Contact from '@/components/Contact.vue'
import CourtesyContact from '@/components/CourtesyContact.vue'
import Dropzone from '@/components/Dropzone.vue'
import LocalStorageService from "@/common/LocalStorageService";
import ModalIdle from "@/components/ModalIdle";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Home'
      },
      component: CommonHome
    },
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Home'
      },
      component: CommonHome
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Home'
      },
      component: Home
    },
    {
      path: '/hce/home',
      name: 'hcehome',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Home'
      },
      component: HceHome
    },
    {
      path: '/hce/createprofile',
      name: 'hcecreateProfile',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Create Profile'
      },
      props:true,
      component: HceCreateProfile
    },
    {
      path: '/hce/editprofile/:id',
      name: 'hceeditprofile',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Edit Profile'
      },
      component: HceEditProfile
    }, {
      path: '/hce/createtransactions',
      name: 'hcetcreatetransactions',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Create Transactions'
      },
      props:true,
      component: HceTranscriptionTerms
    },
    {
      path: '/hce/edittransaction/:id',
      name: 'hceteditransaction',
      meta: {
        requiresAuth: true,
        title: 'HEP Data Portal Edit Transaction'
      },
      props:true,
      component: HceEditranscriptionTerms
    },
    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false,
        title: 'Timeout'
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false,
        title: 'Unauthorized'
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },
    {
      path: '/dropzone',
      name: 'dropzone',
      meta: {
        requiresAuth: true,
        title: 'File Upload'
      },
      component: Dropzone
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        requiresAuth: true,
        title: 'Plan Search'
      },
      component: Search
    },
    {
      path: '/plan/:id',
      name: 'plan',
      meta: {
        requiresAuth: true
      },
      component: Plan
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        requiresAuth: true,
        title: 'Plan Contact'
      },
      component: Contact
    },
    {
      path: '/courtesyContact',
      name: 'courtesyContact',
      meta: {
        requiresAuth: true,
        title: 'Plan Courtesy Contact'
      },
      component: CourtesyContact
    },
    {
      path: '/emailsearch',
      name: 'emailsearch',
      meta: {
        requiresAuth: true,
        title: 'Email Search'
      },
      component: EmailSearch
    },
    {
      path: '/viewcontact',
      name: 'viewcontact',
      meta: {
        requiresAuth: true,
        title: 'View the Contact'
      },
      component: ViewContact
    },
    {
      path: '/demographicsForm/:id',
      name: 'demographicsForm',
      meta: {
        requiresAuth: true,
        title: 'Demographic Form'
      },
      component: DemographicsForm
    },
    {
      path: '/modalIdle/',
      name: 'modalIdle',
      meta: {
        requiresAuth: true,
        title: 'Inactivity time out'
      },
      component: ModalIdle
    },
    {
      path: '*',
      meta: {
        title: 'HEP Data Portal'
      },
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized')
        }
      } else {
        next();
      }
    } else {
      const url = localStorageService.getLoginUrl()
      window.location.replace(url)
    }
  } else {
    next()
  }
})

export default router
